import React from 'react';
import PropTypes from 'prop-types';

const ORELogo = ({ className }) => (
  <svg
    className={`MuiSvgIcon-root ${className}`}
    width="24"
    height="15"
    viewBox="0 0 24 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M24 7.49928C24 11.9951 20.7123 15 16.1107 15H7.8893C3.39021 15 0 11.9951 0 7.49928C0 3.02502 3.28769 0 7.8893 0H16.1093C20.7109 0.00287549 24 3.02214 24 7.49928ZM19.3984 7.49928C19.3984 5.67622 18.0628 4.2471 16.1107 4.2471H7.8893C5.93864 4.2471 4.60306 5.67622 4.60306 7.49928C4.60306 9.34391 5.93864 10.7529 7.8893 10.7529H16.1093C18.0614 10.7529 19.3969 9.34822 19.3969 7.49928H19.3984Z" />
    <path
      d="M9.52087 8.33173L12 5.86313L14.4777 8.33173H9.52087Z"
      fill="#E6007E"
    />
  </svg>
);
ORELogo.propTypes = {
  className: PropTypes.string,
};
ORELogo.defaultProps = {
  className: '',
};

export default ORELogo;
